import { useState, useEffect } from "react";

export const useWindowResize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      // Keep the previous object when nothing actually moved. Returning a fresh
      // one unconditionally re-rendered every consumer on every resize event,
      // including the bursts that settle on the same dimensions (orientation
      // change, on-screen keyboard, devtools docking).
      setWindowSize((previous) =>
        previous.width === width && previous.height === height
          ? previous
          : { width, height }
      );
    };

    // Attach the resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
};
